// src/security/SEC_02_03_ForgotPasswordController.jsx

import React from "react";
import AuthWidget from "../../auth/components/AuthWidget";
import { useSearchParams } from "react-router-dom";

/**
 * SEC-02.03 — Forgot Password Controller
 *
 * Hosts the FORGOT_PASSWORD or RESET_PASSWORD mode of AuthWidget.
 * If a 'token' exists in the URL, it switches to completion mode.
 */
export default function SEC_02_03_ForgotPasswordController() {
  const [params] = useSearchParams();
  const token = params.get("token"); // Pulls the token from the email link
  // Determine mode based on token presence
  const initialMode = token ? "RESET_PASSWORD" : "FORGOT_PASSWORD";

  return (
    <main id="main" className="page-main" data-scroll-container>
      <div className="page-main-inner">
        <section className="page-section">
          <div className="page-section__body">
            
            <AuthWidget 
              initialMode={initialMode} 
              resetToken={token} 
            />

          </div>
        </section>
      </div>
    </main>
  );
}